import FormHelperText from '@mui/material/FormHelperText';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import React from 'react';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { selectStyle } from '../../utils/formStyle';
import { FormInputLabel } from './FormInputLabel';

export const FormSelect = React.forwardRef((props, ref) => {
  const { label, error, menus, placeholder = 'SELECT_OPTION', control, customChange, ...rest } = props;
  const { t } = useTranslation();
  return (
    <div className='flex flex-col gap-1'>
      {label && <FormInputLabel label={label} isRequired={rest.required} />}
      <Controller
        control={control}
        name={rest.name}
        rules={rest.rules}
        render={({ field }) => (
          <Select
            sx={selectStyle}
            {...rest}
            inputRef={ref}
            value={field.value}
            error={!!error}
            onChange={(value) => {
              if (customChange) {
                customChange?.();
              }
              field.onChange(value);
            }}
            displayEmpty
            renderValue={(selected) => {
              if (!selected || !field.value) {
                return menus?.length > 0 ? <em>{t(placeholder)}</em> : null;
              }
              return menus.find((el) => el.value === selected)?.label;
            }}
          >
            {menus.map((el) => (
              <MenuItem key={el.value} value={el.value}>
                {el.label}
              </MenuItem>
            ))}
          </Select>
        )}
      />
      {error && <FormHelperText error>{error.message}</FormHelperText>}
    </div>
  );
});

FormSelect.displayName = 'FormSelect';
